import { singularSdk, SingularConfig } from "singular-sdk";

const sdkKey = process.env.REACT_APP_SINGULAR_SDK_KEY ?? "";
const sdkSecret = process.env.REACT_APP_SINGULAR_SDK_SECRET ?? "";
const productId = process.env.REACT_APP_SINGULAR_PRODUCT_ID ?? "";

export function initializeSingular() {
  if (!sdkKey || !sdkSecret) return;

  const config = new SingularConfig(
    sdkKey,
    sdkSecret,
    productId,
  ).withSessionTimeoutInMinutes(30);

  singularSdk.init(config);
}
